import { render, staticRenderFns } from "./v-arrow.vue?vue&type=template&id=41600c9c&scoped=true&"
import script from "./v-arrow.vue?vue&type=script&lang=js&"
export * from "./v-arrow.vue?vue&type=script&lang=js&"
import style0 from "./v-arrow.vue?vue&type=style&index=0&id=41600c9c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41600c9c",
  null
  
)

export default component.exports